import MainLayout from "@/components/PatientLayout/MainLayout";
import Introduction from "@/components/PatientIntroduction/index";

const PatientHome = () => {
  return (
    <MainLayout>
      <Introduction />
    </MainLayout>
  )
}

export default PatientHome